"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Brightness: () => Brightness
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneBrightness");
  return hybrid;
}
function get() {
  return native().get().catch(import_nativeError.rethrowNativeError);
}
function set(value) {
  (0, import_validate.assertBrightnessValue)(value, "Brightness.set");
  return native().set(value).catch(import_nativeError.rethrowNativeError);
}
function getSystem() {
  return native().getSystem().catch(import_nativeError.rethrowNativeError);
}
function setSystem(value) {
  (0, import_validate.assertBrightnessValue)(value, "Brightness.setSystem");
  return native().setSystem(value).catch(import_nativeError.rethrowNativeError);
}
function getSystemMode() {
  return native().getSystemMode().catch(import_nativeError.rethrowNativeError);
}
function setSystemMode(mode) {
  (0, import_validate.assertSystemMode)(mode);
  return native().setSystemMode(mode).catch(import_nativeError.rethrowNativeError);
}
function isUsingSystem() {
  return native().isUsingSystem().catch(import_nativeError.rethrowNativeError);
}
function restoreSystem() {
  return native().restoreSystem().catch(import_nativeError.rethrowNativeError);
}
function getPermissions() {
  return native().getPermissions().catch(import_nativeError.rethrowNativeError);
}
function requestPermissions() {
  return native().requestPermissions().catch(import_nativeError.rethrowNativeError);
}
function isAvailable() {
  return native().isAvailable();
}
function addListener(listener) {
  (0, import_validate.assertBrightnessListener)(listener);
  var remove = native().addListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
var Brightness = Object.freeze({
  get,
  set,
  getSystem,
  setSystem,
  getSystemMode,
  setSystemMode,
  isUsingSystem,
  restoreSystem,
  getPermissions,
  requestPermissions,
  isAvailable,
  addListener
});
//# sourceMappingURL=index.native.js.map
